import fetchWithCsrf from "../../helper/fetch-with-csrf";
import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from "../messages";
import Logger from "../logger";
import Url from '../../helper/url';

export default async function changeItem(id,
                                         newItemId,
                                         newItemOptionId,
                                         newQuantity,
                                         origin,
                                         isLastCheckPage,
                                         quantity,
                                         itemNumber,
                                         productId,
                                         singlePrice,
                                         posNr) {
    const url = isLastCheckPage ? "/buy/lastcheck/change-item/" : "/buy/cart/change-item/";
    const response = await fetchWithCsrf(Url.toAbsolute(url),
        {
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                id,
                newItemId,
                newItemOptionId,
                newQuantity,
                quantity,
                itemNumber,
                productId,
                singlePrice,
                posNr
            })
        });

    if (response.redirected) {
        window.location.href = response.url;
        return null;
    }

    if (!response.ok) {
        Logger.error("Changing item in cart failed", new Error(response.statusText));
        MessageBroker.publish(Messages.CART.ITEM_CHANGE_ERROR, {id, newItemId, newItemOptionId, newQuantity, origin});
        throw new Error(`HTTP error ${response.status} while change item`);
    }

    const data = await response.json();
    MessageBroker.publish(Messages.CART.ITEM_CHANGE_SUCCESS, {
        id,
        newItemId,
        newItemOptionId,
        newQuantity,
        origin,
        isLastCheckPage,
        data
    });

    if (isLastCheckPage) {
        if (data?.lastCheckSummary?.cart === null) {
            throw new Error(`empty cart while change item`);
        }
        return data;
    } else {
        if (data?.cart === null) {
            throw new Error(`empty cart while change item`);
        }
        return data.cart;
    }
}
